import "rxjs/add/operator/map";

import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";

import { environment } from "../../environments/environment";
import { User } from "../models/user.model";
import { Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";

const settingsFeatures = [
  { Name: "UI::ReconDepositSettings", App: "Inmar.Healthcare.Recon" },
  { Name: "Put::ReconDepositSettings", App: "Inmar.Healthcare.Recon" },
];

@Injectable()
export class AuthorizationService {
  private healthcareTopBar: any;
  private CHECK_IF_TOPBAR_HAS_LOADED_INTERVAL = 1000;
  private _topBarLoaded = false;
  private features: any[] = [];
  private timer: any;

  private readyResolved = false;
  private _readyResolve?: () => void;
  readonly ready = new Promise<void>((res) => {
    this._readyResolve = res;
  });
  private healthcareLoadedSubject = new Subject<void>();
  public healthcareLoadedSubject$ = this.healthcareLoadedSubject.asObservable();

  constructor(private _http: HttpClient) {
    this.timer = setInterval(() => {
      this.waitForTopBarToLoad();
    }, this.CHECK_IF_TOPBAR_HAS_LOADED_INTERVAL);
  }

  public setHealthcareTopBar(topBar: any) {
    this.healthcareTopBar = topBar;
  }

  public get HealthcareTopBar(): any {
    return this.healthcareTopBar ? this.healthcareTopBar : null;
  }

  public get topBarLoaded() {
    return this._topBarLoaded;
  }

  public async waitUntilReady(): Promise<void> {
    return this.ready;
  }

  public async isAuthenticated(): Promise<boolean> {
    await this.waitUntilReady();
    return this.healthcareTopBar.healthcareAuth.isAuthenticated();
  }

  private waitForTopBarToLoad(): boolean {
    if (!this.HealthcareTopBar || !this.HealthcareTopBar.currentUserDetails) {
      return false;
    }

    this.features = this.HealthcareTopBar.currentUserDetails.Features.filter(
      (obj) =>
        obj.App === environment.applicationName ||
        obj.App === environment.applicationName
    );

    this._topBarLoaded = true;

    if (!this.readyResolved) {
      this.readyResolved = true;

      if (this._readyResolve) {
        this._readyResolve();
      }
    }

    this.healthcareLoadedSubject.next();
    clearTimeout(this.timer);
    return true;
  }

  // Do not bind this without using cache to the DOM
  public hasFeature(featureName: string, useCache: boolean = false): boolean {
    if (!this.HealthcareTopBar || !this.HealthcareTopBar.currentUserDetails) {
      return false;
    }

    const collection = useCache
      ? this.features
      : this.HealthcareTopBar.currentUserDetails.Features;

    // First check for APPLINK
    const hasApplink = collection.some(
      (f) =>
        f.Name === environment.applicationApplinkFeature &&
        f.App === environment.applicationName
    );

    // If they don't have APPLINK, they don't have any access
    if (!hasApplink) {
      return false;
    }

    // Now check for the requested feature (this also works when featureName IS APPLINK)
    const hasRequestedFeature = collection.some(
      (f) => f.Name === featureName && f.App === environment.applicationName
    );

    return hasRequestedFeature;
  }

  // Business rule - only show the gear icon if the user has the Get feature or the Get and Put feature.
  // Having only the put feature doesn't make sense, so we won't show the user anything if this is the case.
  // HasFeature will also check for APPLINK access first, if they don't have that, this method will return false thus hiding the settings icon.
  public get showSettingsIcon(): boolean {
    let useCache = true;
    if (!this.features || this.features.length < 1) {
      useCache = false;
    }
    let rollup: boolean =
      this.hasFeature(settingsFeatures[0].Name, useCache) ||
      (this.hasFeature(settingsFeatures[0].Name, useCache) &&
        this.hasFeature(settingsFeatures[1].Name, useCache));
    return rollup;
  }

  CurrentUser(): Observable<User> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this._http.get<User>(`${environment.authZApiRoot.url}/CurrentUser`, {
      headers,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authorization.service.ts